import clsx from "clsx";
import React from "react";

import { DataBox, DataBoxGroup } from "@transfr-inc/dashboard-components";

import { StatusFilter } from "./classroom.modules.utils";
import "./classroom.databoxes.scss";

import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

export function ClassroomSimulationsFilter({
  masteryStats,
  onStatusSelected,
  className,
  disabled,
}) {
  const {
    totalInProgress = 0,
    totalMastered = 0,
    totalWheelSpinning = 0,
    totalSims = 0,
  } = masteryStats || {};
  const totalStarted = totalInProgress + totalMastered + totalWheelSpinning;

  return (
    <div className={clsx("databoxes-section", className)}>
      <DataBoxGroup>
        <DataBox
          label="Started"
          value={totalStarted ?? ""}
          description={`Sims that have been mastered, need work, or where the ${getLearnerTerm(
            { lowercase: true, plural: true }
          )} are stuck.`}
          onClick={() => onStatusSelected(StatusFilter.Started)}
          disabled={disabled}
        ></DataBox>
        <DataBox
          label="Mastered"
          value={totalMastered ?? ""}
          description={`The ${getLearnerTerm({
            lowercase: true,
            plural: true,
          })} have completed the sim and received a score of 90% or higher.`}
          onClick={() => onStatusSelected(StatusFilter.Mastered)}
          disabled={disabled}
        ></DataBox>
        <DataBox
          label="Needs work"
          value={totalInProgress ?? ""}
          description={`The ${getLearnerTerm({
            lowercase: true,
            plural: true,
          })} have started the sim but haven't achieved mastery yet.`}
          onClick={() => onStatusSelected(StatusFilter.InProgress)}
          disabled={disabled}
        ></DataBox>
        <DataBox
          label="Stuck"
          value={totalWheelSpinning ?? ""}
          description={`The ${getLearnerTerm({
            lowercase: true,
            plural: true,
          })} have not made progress in improving their sim score.`}
          onClick={() => onStatusSelected(StatusFilter.Stuck)}
          disabled={disabled}
        ></DataBox>
        <DataBox
          label="All"
          value={totalSims ?? ""}
          description="All sims regardless of status."
          onClick={() => onStatusSelected(StatusFilter.All)}
          disabled={disabled}
        ></DataBox>
      </DataBoxGroup>
    </div>
  );
}
